export default __webpack_public_path__ + "static/media/DV360.2c0ff87a.png";